import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./react-host.css";

// StrictMode is deliberately omitted. The preserved portal runtimes own long-lived
// SignalR connections and must initialise exactly once, including during local dev.
createRoot(document.getElementById("root")).render(<App />);
